'use client';

import loaderImage from 'assets/images/splash.webp';

import { useEffect, useState } from 'react';
import Image from 'next/image';
import { HeroSection } from 'components/ultrasignal/HeroSection';

import styles from './ultrasignal-client.module.css';

export default function UltraSignal() {
  const [isLoading, setLoading] = useState(true);

  const bulletPoints = [
    {
      text: `Submit a brief application for an Ultrahuman Ring AIR developer
              kit.`,
    },
    {
      text: `Applications will be reviewed and priority will be given to
              applicants creating an app that takes advantage of Ultrahuman Ring
              AIR’s data.`,
    },
    {
      text: `If selected, we’ll loan you Ultrahuman Ring developer kit to
              prepare your app.`,
    },
  ];

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <>
      <main>
        <HeroSection
          tag="Introducing UltraSignal"
          title="World’s first wearable-based developer platform."
          subtitle="Using the Ring AIR's Photoplethysmography (PPG), temperature and accelerometer data stream, developers can now build bespoke algorithms on top of their data."
          ctaType="primary"
          // ctaDescription="JOIN THE WAITLIST"
          ctaText="Get Access"
          iframe="https://unicorn.studio/embed/C0XlH8smsOLQgZ0RTY3U"
        />
        <HeroSection
          align="left"
          bg="light"
          title="How it works"
          bulletPoints={bulletPoints}
          ctaType="secondary"
          ctaText="Get Access"
          imgSrc="web_v2/illustrations/air-aster-black/2.png/w_1080"
        />
      </main>
      {isLoading && (
        <div className={styles.loader}>
          <Image src={loaderImage} alt="UH loading" />
        </div>
      )}
    </>
  );
}
